var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"div-checkup"}},[_c('b-link',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('b-card',{attrs:{"stretch":"","overlay":"","img-src":require('@/assets/images/banner/checkupReport.png')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }